// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-tabs .react-tabs__tab-list {
  border: none;
  margin: 0;
  height: 648px;
  overflow-y: auto;
  padding-right: 10px;
}
.chat-tabs .react-tabs__tab-list .react-tabs__tab {
  display: block;
  padding: 5px 0;
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #F7FAFF;
}
.chat-tabs .react-tabs__tab-list .react-tabs__tab:focus, .chat-tabs .react-tabs__tab-list .react-tabs__tab:focus-visible {
  outline: 0;
}
.chat-tabs .react-tabs__tab-list .react-tabs__tab:focus:after, .chat-tabs .react-tabs__tab-list .react-tabs__tab:focus-visible:after {
  background: transparent;
}
.chat-tabs .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {
  background-color: #fdfdfd;
  color: #A9A9C8;
}

.active-status {
  width: 13px;
  height: 13px;
  position: absolute;
  bottom: 4px;
  right: 3px;
  border: 2px solid #fff;
  border-radius: 100%;
}

.active-status2 {
  width: 13px;
  height: 13px;
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 100%;
  position: relative;
  top: 1px;
}

.left-replay-box {
  position: relative;
}

.left-replay-box .hover-caption {
  background: #fff;
  box-shadow: 0px 10px 35px rgba(50, 110, 189, 0.2);
  border-radius: 10px;
  visibility: hidden;
  transition: 0.6s;
  position: absolute;
  left: 0;
  top: 30px;
}

.left-replay-box:hover .hover-caption {
  visibility: visible;
}

.right-replay-box {
  position: relative;
}

.right-replay-box .hover-caption {
  background: #fff;
  box-shadow: 0px 10px 35px rgba(50, 110, 189, 0.2);
  border-radius: 10px;
  visibility: hidden;
  transition: 0.6s;
  position: absolute;
  right: 0;
  top: 30px;
}

.right-replay-box:hover .hover-caption {
  visibility: visible;
}

.chat-list-box {
  padding: 15px;
  height: 585px;
  overflow: auto;
}

[dir=rtl] .chat-tabs .react-tabs__tab-list {
  padding-right: 0;
  padding-left: 10px;
}
[dir=rtl] .active-status {
  right: 0;
  left: 3px;
}
[dir=rtl] .left-replay-box .hover-caption {
  left: auto;
  right: 0;
}
[dir=rtl] .right-replay-box .hover-caption {
  right: auto;
  left: 0;
}

/* For dark mode */
[class=dark] .chat-tabs .react-tabs__tab-list .react-tabs__tab {
  border-bottom: 1px solid var(--borderColor);
}
[class=dark] .chat-tabs .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {
  background-color: var(--colorBlack);
  color: #A9A9C8;
}
[class=dark] .chat-tabs .for-dark-text-white span {
  color: #fff !important;
}
[class=dark] .chat-tabs .for-dark-chat-box {
  border: 1px solid var(--borderColor);
}
[class=dark] .chat-tabs .for-dark-chat-header {
  border-bottom: 1px solid var(--borderColor);
}
[class=dark] .chat-tabs .for-dark-button {
  background: #000;
}`, "",{"version":3,"sources":["webpack://./src/styles/chat.scss","webpack://./src/styles/chat.css"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;ACAJ;ADEI;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;ACAN;ADEM;EACE,UAAA;ACAR;ADCQ;EACE,uBAAA;ACCV;ADGM;EACE,yBAAA;EACA,cAAA;ACDR;;ADMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;ACHF;;ADKA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;ACFF;;ADMA;EACE,kBAAA;ACHF;;ADKA;EACE,gBAAA;EACA,iDAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;ACFF;;ADIA;EACE,mBAAA;ACDF;;ADKA;EACE,kBAAA;ACFF;;ADIA;EACE,gBAAA;EACA,iDAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ACDF;;ADGA;EACE,mBAAA;ACAF;;ADIA;EACE,aAAA;EACA,aAAA;EACA,cAAA;ACDF;;ADQI;EACE,gBAAA;EACA,kBAAA;ACLN;ADSE;EACE,QAAA;EACA,SAAA;ACPJ;ADWE;EACE,UAAA;EACA,QAAA;ACTJ;ADaE;EACE,WAAA;EACA,OAAA;ACXJ;;ADeA,kBAAA;AAII;EACE,2CAAA;ACfN;ADiBM;EACE,mCAAA;EACA,cAAA;ACfR;ADqBI;EACE,sBAAA;ACnBN;ADuBE;EACE,oCAAA;ACrBJ;ADuBE;EACE,2CAAA;ACrBJ;ADuBE;EACE,gBAAA;ACrBJ","sourcesContent":[".chat-tabs {\n  .react-tabs__tab-list {\n    border: none;\n    margin: 0;\n    height: 648px;\n    overflow-y: auto;\n    padding-right: 10px;\n \n    .react-tabs__tab {\n      display: block;\n      padding: 5px 0;\n      border-radius: 0;\n      border-top: none;\n      border-left: none;\n      border-right: none;\n      border-bottom: 1px solid #F7FAFF;\n\n      &:focus, &:focus-visible {\n        outline: 0;\n        &:after {\n          background: transparent;\n        }\n      }\n\n      &.react-tabs__tab--selected {\n        background-color: #fdfdfd;\n        color: #A9A9C8;\n      }\n    }\n  }\n}\n.active-status {\n  width: 13px;\n  height: 13px; \n  position: absolute;\n  bottom: 4px;\n  right: 3px;\n  border: 2px solid #fff;\n  border-radius: 100%;\n}\n.active-status2 {\n  width: 13px;\n  height: 13px; \n  display: inline-block;\n  border: 2px solid #fff;\n  border-radius: 100%;\n  position: relative;\n  top: 1px;\n}\n\n// left-replay-box\n.left-replay-box {\n  position: relative;\n}\n.left-replay-box .hover-caption {\n  background: #fff;\n  box-shadow: 0px 10px 35px rgba(50, 110, 189, 0.2);\n  border-radius: 10px;\n  visibility: hidden;\n  transition: .6s;\n  position: absolute; \n  left: 0;\n  top: 30px;\n}\n.left-replay-box:hover .hover-caption {\n  visibility: visible;\n}\n\n// right-replay-box\n.right-replay-box {\n  position: relative;\n}\n.right-replay-box .hover-caption {\n  background: #fff;\n  box-shadow: 0px 10px 35px rgba(50, 110, 189, 0.2);\n  border-radius: 10px;\n  visibility: hidden;\n  transition: .6s;\n  position: absolute; \n  right: 0;\n  top: 30px;\n}\n.right-replay-box:hover .hover-caption {\n  visibility: visible;\n}\n\n// chat-list-box\n.chat-list-box {\n  padding: 15px;\n  height: 585px;\n  overflow: auto;\n}\n\n\n// For RTL Style\n[dir=\"rtl\"] {\n  .chat-tabs {\n    .react-tabs__tab-list {\n      padding-right: 0;\n      padding-left: 10px;\n    }\n  }\n  \n  .active-status {\n    right: 0;\n    left: 3px;\n  }\n  \n  // left-replay-box\n  .left-replay-box .hover-caption {\n    left: auto;\n    right: 0;\n  }\n  \n  // right-replay-box\n  .right-replay-box .hover-caption {\n    right: auto;\n    left: 0;\n  }\n}\n\n/* For dark mode */\n[class=\"dark\"] .chat-tabs {\n  .react-tabs__tab-list {\n    \n    .react-tabs__tab {\n      border-bottom: 1px solid var(--borderColor);\n\n      &.react-tabs__tab--selected {\n        background-color: var(--colorBlack);\n        color: #A9A9C8;\n      }\n    }\n  }\n\n  .for-dark-text-white {\n    span {\n      color: #fff !important;\n    }\n  }\n\n  .for-dark-chat-box {\n    border: 1px solid var(--borderColor);\n  }\n  .for-dark-chat-header {\n    border-bottom: 1px solid var(--borderColor);\n  }\n  .for-dark-button {\n    background: #000;\n  }\n}",".chat-tabs .react-tabs__tab-list {\n  border: none;\n  margin: 0;\n  height: 648px;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n.chat-tabs .react-tabs__tab-list .react-tabs__tab {\n  display: block;\n  padding: 5px 0;\n  border-radius: 0;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 1px solid #F7FAFF;\n}\n.chat-tabs .react-tabs__tab-list .react-tabs__tab:focus, .chat-tabs .react-tabs__tab-list .react-tabs__tab:focus-visible {\n  outline: 0;\n}\n.chat-tabs .react-tabs__tab-list .react-tabs__tab:focus:after, .chat-tabs .react-tabs__tab-list .react-tabs__tab:focus-visible:after {\n  background: transparent;\n}\n.chat-tabs .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {\n  background-color: #fdfdfd;\n  color: #A9A9C8;\n}\n\n.active-status {\n  width: 13px;\n  height: 13px;\n  position: absolute;\n  bottom: 4px;\n  right: 3px;\n  border: 2px solid #fff;\n  border-radius: 100%;\n}\n\n.active-status2 {\n  width: 13px;\n  height: 13px;\n  display: inline-block;\n  border: 2px solid #fff;\n  border-radius: 100%;\n  position: relative;\n  top: 1px;\n}\n\n.left-replay-box {\n  position: relative;\n}\n\n.left-replay-box .hover-caption {\n  background: #fff;\n  box-shadow: 0px 10px 35px rgba(50, 110, 189, 0.2);\n  border-radius: 10px;\n  visibility: hidden;\n  transition: 0.6s;\n  position: absolute;\n  left: 0;\n  top: 30px;\n}\n\n.left-replay-box:hover .hover-caption {\n  visibility: visible;\n}\n\n.right-replay-box {\n  position: relative;\n}\n\n.right-replay-box .hover-caption {\n  background: #fff;\n  box-shadow: 0px 10px 35px rgba(50, 110, 189, 0.2);\n  border-radius: 10px;\n  visibility: hidden;\n  transition: 0.6s;\n  position: absolute;\n  right: 0;\n  top: 30px;\n}\n\n.right-replay-box:hover .hover-caption {\n  visibility: visible;\n}\n\n.chat-list-box {\n  padding: 15px;\n  height: 585px;\n  overflow: auto;\n}\n\n[dir=rtl] .chat-tabs .react-tabs__tab-list {\n  padding-right: 0;\n  padding-left: 10px;\n}\n[dir=rtl] .active-status {\n  right: 0;\n  left: 3px;\n}\n[dir=rtl] .left-replay-box .hover-caption {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .right-replay-box .hover-caption {\n  right: auto;\n  left: 0;\n}\n\n/* For dark mode */\n[class=dark] .chat-tabs .react-tabs__tab-list .react-tabs__tab {\n  border-bottom: 1px solid var(--borderColor);\n}\n[class=dark] .chat-tabs .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {\n  background-color: var(--colorBlack);\n  color: #A9A9C8;\n}\n[class=dark] .chat-tabs .for-dark-text-white span {\n  color: #fff !important;\n}\n[class=dark] .chat-tabs .for-dark-chat-box {\n  border: 1px solid var(--borderColor);\n}\n[class=dark] .chat-tabs .for-dark-chat-header {\n  border-bottom: 1px solid var(--borderColor);\n}\n[class=dark] .chat-tabs .for-dark-button {\n  background: #000;\n}/*# sourceMappingURL=chat.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
